// extracted by mini-css-extract-plugin
export var content = "_cm-3";
export var list = "_cm-4";
export var settingsContent = "_cm-7";
export var settingsPanel = "_cm-8";
export var state = "_cm-6";
export var triggerBadge = "_cm-2";
export var triggerButton = "_cm-1";
export var triggerShell = "_cm-0";
export var unreadDot = "_cm-5";